import script from "./CartPayment.vue?vue&type=script&setup=true&lang=js"
export * from "./CartPayment.vue?vue&type=script&setup=true&lang=js"

import "./CartPayment.vue?vue&type=style&index=0&id=d3e2a98a&lang=css"

const __exports__ = script;

export default __exports__